import { MessageCircle, Phone, Zap } from "lucide-react";
import { waLink, WA_DEFAULT_MSG, PHONE_NUMBER_TEL, PHONE_DISPLAY } from "@/lib/site";

const links = [
  { href: "#servizi", label: "Servizi" },
  { href: "#tariffe", label: "Tariffe" },
  { href: "#b2b", label: "B2B" },
  { href: "#come-funziona", label: "Come Funziona" },
  { href: "#faq", label: "FAQ" },
];

export default function Header() {
  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <div className="bg-[#FF5500] text-white" data-testid="emergency-banner">
        <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-1.5">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping-slow absolute inline-flex h-full w-full rounded-full bg-white" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-white" />
          </span>
          <p className="font-mono-accent text-[10px] font-bold uppercase tracking-[0.18em] sm:text-xs">
            4 tecnici attivi ora in scooter a Napoli — tempo medio d'arrivo oggi: 38 min
          </p>
        </div>
      </div>
      <header className="border-b border-white/10 bg-[#060B19]/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <a href="#top" data-testid="header-logo" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-[#FF5500]">
              <Zap className="h-5 w-5 text-white" strokeWidth={2.5} />
            </span>
            <span className="font-display text-2xl font-black uppercase tracking-tight">
              El Mastro<span className="text-[#FFB800]">.</span>
            </span>
          </a>
          <nav className="hidden items-center gap-7 lg:flex" data-testid="header-nav">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/ /g, "-")}`}
                className="text-sm font-medium text-slate-300 transition-colors duration-200 hover:text-[#FFB800]"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <a
              href={`tel:${PHONE_NUMBER_TEL}`}
              data-testid="header-phone-link"
              className="hidden items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm font-semibold text-slate-200 transition-colors duration-200 hover:border-[#FFB800]/60 hover:text-[#FFB800] md:flex"
            >
              <Phone className="h-4 w-4" />
              {PHONE_DISPLAY}
            </a>
            <a
              href={waLink(WA_DEFAULT_MSG)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-whatsapp-cta"
              className="flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2 text-sm font-bold text-[#04140a] transition-transform duration-200 hover:scale-[1.04] active:scale-95"
            >
              <MessageCircle className="h-4 w-4" strokeWidth={2.5} />
              WhatsApp
            </a>
          </div>
        </div>
      </header>
    </div>
  );
}
